export default __webpack_public_path__ + "static/img-ei-2-506ea9600a2ee330c09cfe2c98d4f047.png";